'use strict';

var _ = require('lodash');
var ImportCsvModalDirective = function ImportCsvModalDirective($timeout) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/import-csv-modal.html'),
    controller: 'ImportCsvModalController',
    scope: {
      errorGridState: '=',
      localImportHandler: '=',
      showDetailedErrorMessage: '='
    },
    link: function link(scope, element) {
      scope.showImportModal = function () {
        element.modal('show');
      };
      scope.$on('grid:showImportModal', function (event, gridId, mode, scenarioName, calibrationName) {
        scope.initConfig(gridId, mode, scenarioName, calibrationName);
        scope.showImportModal();
      });
      scope.$on('configuration-market-class-fare:errorLogClose', function () {
        scope.hideErrorLog();
      });
      function resetInput(elem) {
        elem.wrap('<form>').closest('form').get(0).reset();
        elem.unwrap();
      }
      element.on('hidden.bs.modal', function () {
        resetInput(element.find('#import-browse-button'));
      });
      element.find('#import-browse-button').bind('change', function (event) {
        $timeout(function () {
          var file = _.first(event.target.files);
          var fileName = _.isUndefined(file) ? '' : file.name;
          if (_.endsWith(fileName, '.csv') || _.endsWith(fileName, '.zip')) {
            scope.chosenFileName = fileName;
            scope.chosenFile = file;
          } else {
            scope.chosenFileName = '';
            scope.chosenFile = null;
          }
        }, 0);
      });
    }
  };
};
ImportCsvModalDirective.$inject = ['$timeout'];
module.exports = ImportCsvModalDirective;